<script setup lang="ts">
import { generateAbsoluteLink } from "@/lib/utils.js"

const link = generateAbsoluteLink("files/Editorial_Rules_2022.pdf")
</script>

<template>
  <p class="mb-8 text-lg">
    «Studi musicali» publishes articles in all fields of musicological research in Italian, English, French, German and
    Spanish. Authors can submit articles in digital format at the following email address:
    <a href="mailto:studimusicali@santacecilia.it" class="classic-link">studimusicali@santacecilia.it</a>,
    <a href="mailto:tgialdroni@gmail.com" class="classic-link">tgialdroni@gmail.com</a>. Publication is subject to
    review by two specialised referees, who will review the articles anonymously. Upon acceptance, the article will have
    to be formatted according to the <a :href="link" class="classic-link" target="_blank">Editorial Guidelines</a> of
    the journal available in Italian and English (below). Acceptance of the article will be communicated to authors,
    with the specification of the issue were it will be published. All information about format and resolution of
    possible accompanying images are also available in the
    <a :href="link" class="classic-link" target="_blank">Editorial Guidelines</a>. An indicative publication date will
    be provided, keeping in mind that the journal is a six-monthly and that the first issue is usually published by end
    of the current year, and the next one at the beginning of the next year.
  </p>
</template>
